'use strict';
import {
  ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter
} from '@angular/core';
import { get } from 'lodash';
import { ICurationItem } from '../../../../../interfaces/curation-item.interface';
import { CurationSettings } from '../../../../curation-dashboard/curation-setting';
import { ExternalSearchService } from '../../../../../../shared/services/external-search.service';
import { CurationUtils } from '../../../../../utils/curation-utils';

@Component({
  selector: 'gen-curation-editor-aberration-details',
  templateUrl: './curation-editor-aberration-details.component.html',
  styleUrls: ['./curation-editor-aberration-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationEditorAberrationDetailsComponent implements OnInit {
  @Input() readOnly: boolean;
  @Input() aberrationDetailsFormName: string;
  @Input() inlineEdit: boolean;
  @Input() approvedMode: boolean = false;
  @Input() revisionTag: string;
  @Input() submitted: boolean = false;
  @Input() verticalForm: boolean;
  @Input() searchDataConfigParams: any;
  @Input() googleSearchURL: string;
  @Input() pubmedSearchURL: string;
  @Output() validated: EventEmitter<{ elementKey: string, validationStatus: boolean}> = new EventEmitter();
  @Output() aberrationDataChanged: EventEmitter<any> = new EventEmitter();

  private _curationItem: ICurationItem;
  public formData: any = { };
  public showTable: boolean = false;

  public tableHeadElements = ['Coding Change', 'Coding Transcript', 'Protein Change', 'Protein Identifier'];
/*  public elements: any = {
    "genomicNotation": "NC_000017.10:g.48275363C>A",
    "grch": "grch37",
    "data": [
      {
        "codingChange": "c.589G>T",
        "codingTranscript": "ENST00000225964.5",
        "proteinChange": "p.Gly197Cys",
        "proteinIdentifier": "ENSP00000225964.5"
      },
      {
        "codingChange": "n.316G>T",
        "codingTranscript": "ENST00000495677.1"
      },
      {
        "codingChange": "c.589G>T",
        "codingTranscript": "NM_000088.3",
        "proteinChange": "p.Gly197Cys",
        "proteinIdentifier": "NP_000079.2"
      },
      {
        "codingChange": "c.589G>T",
        "codingTranscript": "XM_005257058.1",
        "proteinChange": "p.Gly197Cys",
        "proteinIdentifier": "XP_005257115.1"
      },
      {
        "codingChange": "c.589G>T",
        "codingTranscript": "XM_005257059.1",
        "proteinChange": "p.Gly197Cys",
        "proteinIdentifier": "XP_005257116.1"
      }
    ]
  }*/

  get updatedFieldsContext() {
    return this.approvedMode ? null : this.revisionTag;
  }

  constructor(private externalSearchService: ExternalSearchService) {
  }

  ngOnInit() {
  }

  @Input() set curationItem(data: ICurationItem) {
    this._curationItem = data;
    this.showTable = (get(data, 'curationData.variantTranslation.data') != undefined);
    this.formData = CurationUtils.getFlatAberrationData(this._curationItem);
    this.fillForm();
    this.fillCalcFields();
  }

  get curationItem(): ICurationItem {
    return this._curationItem;
  }

  private fillForm() {
    if (this._curationItem) {
      this.formData.disease = this._curationItem.diseaseDisplay;
      this.formData.AberrationType = this._curationItem.aberration.AberrationClass;
      this.formData.gene = this._curationItem.aberration.gene;
      this.formData.AAChange = this._curationItem.aberration.AAChange;

      if (this._curationItem.curationData['manualAnnotations']) {
        Object.assign(this.formData, this._curationItem.curationData['manualAnnotations']);
      }
      if (this._curationItem.annotations) {
        for (let i = 0; i < this._curationItem.annotations.length; i++) {
          const annotationSource = this._curationItem.annotations[i];
          for (let j = 0; j < annotationSource['annotations'].length; j++) {
            const annotation = annotationSource['annotations'][j];
            this.formData[annotation['name']] = annotation['value'];
          }
        }
      }
      if (this._curationItem.aberration) {
        Object.assign(this.formData, this._curationItem.aberration);
      }
    }
  }

  updateForm(form, updateFieldKeys: any) {
    if (this._curationItem.curationData['manualAnnotations'] == null) {
      this._curationItem.curationData['manualAnnotations'] = { };
    }
    if (updateFieldKeys) {
      for (const key of updateFieldKeys) {
        this._curationItem.curationData['manualAnnotations'][key] = form[key];
        // console.log('key = ' + key + ', value = ' + form[key]);
      }
      this.aberrationDataChanged.emit(this._curationItem.curationData['manualAnnotations']);
    }
  }

  private fillCalcFields() {

    // fill chromosalPosition
    if (this._curationItem) {
      if (this._curationItem.aberration.chrom && this._curationItem.aberration.pos) {
        this.formData.chromosomalPosition = this._curationItem.aberration.chrom + ':' + this._curationItem.aberration.pos;
      }
      if (this._curationItem.metadata['aberrationSubClass'] &&
        this._curationItem.metadata['aberrationSubClass'] === 'regionbased' &&
        this._curationItem.aberration.start && this._curationItem.aberration.end &&
        this._curationItem.aberration.end >= this._curationItem.aberration.start) {
        this.formData.length = this._curationItem.aberration.end - this._curationItem.aberration.start;
      }
    }
  }

  validationEvent(valid) {
    if (!this.readOnly) {
      this.validated.emit({
        elementKey: CurationSettings.CURATION_ABERRATION,
        validationStatus: valid
      });
    }
  }

  linkClicked($event) {
    const searchType = $event['linkText'];
    const url: string = searchType.toLowerCase() == 'google' ? this.googleSearchURL : this.pubmedSearchURL;
    const link = this.externalSearchService.getSearchQueryByTemplate(url, this.searchDataConfigParams,
                CurationUtils.getFlatAberrationData(this._curationItem), $event.template);
    $event.updatedLink = link;
  }
}
